export const POST_STATUS_REQUEST = "POST_STATUS_REQUEST";
export const POST_STATUS_SUCCESS = "POST_STATUS_SUCCESS";
export const POST_STATUS_FAIL = "POST_STATUS_FAIL";
export const POST_STATUS_RESET = "POST_STATUS_RESET";

export const CREATE_POST_REQUEST = "CREATE_POST_REQUEST";
export const CREATE_POST_SUCCESS = "CREATE_POST_SUCCESS";
export const CREATE_POST_FAIL = "CREATE_POST_FAIL";
export const CREATE_POST_RESET = "CREATE_POST_RESET";

export const UPDATE_POST_REQUEST = "UPDATE_POST_REQUEST";
export const UPDATE_POST_SUCCESS = "UPDATE_POST_SUCCESS";
export const UPDATE_POST_FAIL = "UPDATE_POST_FAIL";
export const UPDATE_POST_RESET = "UPDATE_POST_RESET";

export const DELETE_POST_REQUEST = "DELETE_POST_REQUEST";
export const DELETE_POST_SUCCESS = "DELETE_POST_SUCCESS";
export const DELETE_POST_FAIL = "DELETE_POST_FAIL";
export const DELETE_POST_RESET = "DELETE_POST_RESET";

export const ALL_POSTS_REQUEST = "ALL_POSTS_REQUEST";
export const ALL_POSTS_SUCCESS = "ALL_POSTS_SUCCESS";
export const ALL_POSTS_FAIL = "ALL_POSTS_FAIL";

export const LIKE_POST_REQUEST = "LIKE_POST_REQUEST";
export const LIKE_POST_SUCCESS = "LIKE_POST_SUCCESS";
export const LIKE_POST_FAIL = "LIKE_POST_FAIL";
export const LIKE_POST_RESET = "LIKE_POST_RESET";

export const USER_POSTS_REQUEST = "USER_POSTS_REQUEST";
export const USER_POSTS_SUCCESS = "USER_POSTS_SUCCESS";
export const USER_POSTS_FAIL = "USER_POSTS_FAIL";

export const POST_DETAILS_REQUEST = "POST_DETAILS_REQUEST";
export const POST_DETAILS_SUCCESS = "POST_DETAILS_SUCCESS";
export const POST_DETAILS_FAIL = "POST_DETAILS_FAIL";
export const POST_DETAILS_RESET = "POST_DETAILS_RESET";

export const BOOKMARK_POST_REQUEST = "BOOKMARK_POST_REQUEST";
export const BOOKMARK_POST_SUCCESS = "BOOKMARK_POST_SUCCESS";
export const BOOKMARK_POST_FAIL = "BOOKMARK_POST_FAIL";
export const BOOKMARK_POST_RESET = "BOOKMARK_POST_RESET";

export const BOOKMARK_POST_REMOVE_REQUEST = "BOOKMARK_POST_REMOVE_REQUEST";
export const BOOKMARK_POST_REMOVE_SUCCESS = "BOOKMARK_POST_REMOVE_SUCCESS";
export const BOOKMARK_POST_REMOVE_FAIL = "BOOKMARK_POST_REMOVE_FAIL";
export const BOOKMARK_POST_REMOVE_RESET = "BOOKMARK_POST_REMOVE_RESET";

export const SET_CATEGORY = "SET_CATEGORY";
export const SET_TITLE = "SET_TITLE";
export const SET_TAG = "SET_TAG";
export const CLEAR_SEARCH = "CLEAR_SEARCH";
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const SET_PREV_PAGE = "SET_PREV_PAGE";
export const SET_NEXT_PAGE = "SET_NEXT_PAGE";
